import React from "react";
import I18n from "lib/i18n";
import PropTypes from "prop-types";
import { withStyles } from "@theconversation/ui";
import classNames from "classnames";

const COMMENT_MODERATION_PATH = "/editorial/comments_new?filter_region=all&editor_id=:editor_id";

const styles = {
  container: {
    position: "relative",
  },
  notificationBadge: {
    backgroundColor: "#d8352a",
    borderRadius: "8px",
    bottom: "15px",
    height: "15px",
    position: "absolute",
    right: "10px",
    width: "15px",
    // Note: Carlton's setting up a z-index of 200 for anchor tags, so we need to use a bigger value
    // here to avoid the notification badge from disappearing behind the color change hover background transition
    //
    // Relevant selector: ".topbar-dropdown a"
    zIndex: 201,
  },
};

/**
 * Component that'll render a link to the new comment moderation area, linking the editor to comments made
 * on articles they are curating, from all regions.
 *
 * If the editor has new comments on articles they are curating (news feed count bigger than 0), this component
 * will render a notification badge on the right side of the anchor tag.
 */
function CommentModerationLink({ classes, newsFeedCount, userId, visible }) {
  if (visible) {
    const commentModerationPath = COMMENT_MODERATION_PATH.replace(":editor_id", userId);

    return (
      <li className={classNames("comment-moderation", classes.container)}>
        <a href={commentModerationPath}>{I18n.t("top_bar.label.comment_moderation")}</a>

        { newsFeedCount > 0 ? <div className={classes.notificationBadge} /> : null }
      </li>
    );
  }

  return null;
}

CommentModerationLink.defaultProps = {
  classes: {},
  newsFeedCount: 0,
  userId: "",
};

CommentModerationLink.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string,
    notificationBadge: PropTypes.string,
  }),
  newsFeedCount: PropTypes.number,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  visible: PropTypes.bool.isRequired,
};

export default withStyles(styles)(CommentModerationLink);
